<template>
    <div class="privilege-list">
        <div class="tool_list">
            <div :class="['tool_item', index === activeIndex && 'activeTool']" v-for="(item, index) in list"
                :key="index" @click="handlclick(index)">{{ language === 'ug' ? item.ugName : item.name }}</div>
        </div>
        <van-swipe ref="swipe" :loop="false" :lazy-render="true" :initial-swipe="initialId" :show-indicators="false"
            @change="onChange" :autoplay="0">
            <van-swipe-item v-for="(val, i) in list" :key="i">
                <div class="privilege-item-box">
                    <div class="privilege-item" v-for="(item, index) in privilegeList" :key="index">
                        <img class="privilege-item-img" v-lazy="item.img" />
                        <p :class="['privilege-item-title', language == 'ug' && 'privilege-item-title-ug']" :style="{color: index < showColors[activeIndex] ? colors1.get(activeIndex) : '#443B5D'}">{{ $t(item.title) }}</p>
                        <p class="privilege-item-desc" :style="{color: index < showColors[activeIndex]  ? colors2.get(activeIndex) : '#443B5D'}">{{ $t(item.desc) }}</p>
                    </div>
                </div>
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
import Vue from 'vue';
import { Swipe, SwipeItem, Lazyload, Toast } from 'vant';
Vue.use(Lazyload);

export default {
    name: "PrivilegeList",
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem
    },
    props: {
        list: {
            type: Array,
            default: () => []
        },
        language: {
            type: String,
            default: 'ug'
        },
        activedId: {
            type: Number,
            default: 4
        }
    },
    data() {
        return {
            privilegeList: [],
            activeIndex: 0,
            initialId: 10,
            colors1: new Map([
                [0, '#FFFFFF'],
                [1, '#FFFFFF'],
                [2, '#4097F5'],
                [3, '#CC9CFF'],
                [4, '#FF8C7E']
            ]),
            colors2: new Map([
                [0, '#DFDFDF'],
                [1, '#DFDFDF'],
                [2, '#2B73BF'],
                [3, '#9064BF'],
                [4, '#FF8C7E']
            ]),
            showColors: [5,7,9,10,12]
        }
    },
    watch: {
        activedId: {
            handler(val) {
                console.log(val);
                this.activeIndex = val
                this.initialId = val
                this.getPrivilegeList()
            },
            immediate: true
        }
    },
    methods: {
        onChange(index) {
            this.privilegeList = []
            this.activeIndex = index
            this.getPrivilegeList()
        },
        handlclick(index) {
            console.log(index);
            
            this.activeIndex = index
            this.getPrivilegeList()
            this.$nextTick(() => {
                this.$refs['swipe'].swipeTo(this.activeIndex)
            })
        },
        getPrivilegeList() {
            this.privilegeList = []
            const filePath = `noble0${this.activeIndex + 1}`
            this.privilegeList = [
                { img: require(`@/assets/noble/${filePath}/头像框@2x.png`), title: '头像框', desc: '等级专属头像框' },
                { img: require(`@/assets/noble/${filePath}/皮肤卡@2x.png`), title: '皮肤卡', desc: '至尊身份以卡识人' },
                { img: require(`@/assets/noble/${filePath}/等级勋章@2x.png`), title: '等级勋章', desc: '贵族勋章专属标识' },
                { img: require(`@/assets/noble/${filePath}/游戏畅玩@2x.png`), title: '游戏畅玩', desc: '无需加玩伴畅快玩游戏' },
                { img: require(`@/assets/noble/${filePath}/发红包@2x.png`), title: '发钻石红包', desc: '专属功能彰显气派' },
                { img: require(`@/assets/noble/${filePath}/进场特效@2x.png`), title: '进场特效', desc: '璀璨降临震撼全场' },
                { img: require(`@/assets/noble/${filePath}/昵称变色@2x.png`), title: '昵称变色', desc: '专属颜色彰显尊贵' },
                { img: require(`@/assets/noble/${filePath}/气泡框@2x.png`), title: '消息气泡框', desc: '个性消息框更加吸引人' },
                { img: require(`@/assets/noble/${filePath}/弹幕@2x.png`), title: '发弹幕', desc: '专属功能独一无二' },
                { img: require(`@/assets/noble/${filePath}/防踢@2x.png`), title: '防踢', desc: '尊享在房不被踢出' },
                { img: require(`@/assets/noble/${filePath}/礼物@2x.png`), title: '订制礼物', desc: '订制礼物排面十足' },
                { img: require(`@/assets/noble/${filePath}/客服@2x.png`), title: '专属客服', desc: '定向贴心1V1服务' }
            ]
        }
    },
    mounted() {
        this.getPrivilegeList()
    },
}
</script>

<style lang="scss" scoped>
.privilege-list {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: #FFFFFF;
    box-sizing: border-box;
    height: 100%;

    .tool_list {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: scroll;
        height: 22px;

        &::-webkit-scrollbar {
            display: none;
        }

        .tool_item {
            text-wrap: nowrap;
            margin-right: 20px;
            color: #999999;
            font-size: 16px;
        }

        .activeTool {
            color: #FFFFFF;
            position: relative;
            font-weight: 500;
            font-family: 'UKIJCJK';
            &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 50%;
                width: 12px;
                height: 2px;
                transform: translateX(-50%);
                background: #C498FE;
                border-radius: 4px
            }
        }
    }

    .van-swipe {
        flex: 1;
        overflow-y: scroll;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .privilege-item-box {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 9px;
        padding-top: 16px;
    }

    .privilege-item {
        height: 128px;
        background: #1B1337;
        border-radius: 12px;
        text-align: center;
        padding: 12px 6px;

        .privilege-item-img {
            width: 48px;
            height: 48px;
        }

        .privilege-item-title {
            font-weight: 500;
            font-size: 14px;
            color: #FFFFFF;
            padding: 10px 0;
        }

        .privilege-item-title-ug {
            font-family: 'UKIJCJK';
            font-size: 10px;
        }

        .privilege-item-desc {
            width: 100px;
            font-size: 10px;
            color: #DFDFDF;
        }
    }
}
</style>